

document.querySelectorAll("ul.tabs li a").forEach(function (obj) {
  obj.addEventListener("click", function (e) {
    e.preventDefault();
    if (this.classList.contains("active")) {
      return;
    }

    var target = this.getAttribute("href");

    document.querySelector("ul.tabs > li > a.active").classList.remove("active");
    this.classList.add("active");

    document.querySelector(".tabs-content > li.active").classList.remove("active");
    document.querySelector(target).classList.add("active");
  });
});

document.querySelectorAll(".card select[name='id']").forEach(function (obj) {
  obj.addEventListener("change", function (e) {
    var card = obj.closest(".card");
    var img_url = obj.options[obj.selectedIndex].getAttribute("data-image");
    card.querySelector(".card__media img").removeAttribute("srcset");
    card.querySelector(".card__media img").setAttribute("src", img_url);
  });
});


document.addEventListener("DOMContentLoaded", () => {
  
 //disablecartlinks();
  const removeStaleGifts = () => {
  const all_free_gift_ids = [];
  for (let i = 0; i < window.freegifts.products.length; i++) {
    const current_product = window.freegifts.products[i];
    for (let x = 0; x < current_product.tier.length; x++) {
      const current_tier = current_product.tier[x].variants;
      all_free_gift_ids.push(current_tier.map(product => product.id));
    }
  }

  fetch('/cart.js')
    .then(response => response.json())
    .then(response => {
      const cart_data = response;
      for (let i = 0; i < cart_data.items.length; i++) {

        const current = cart_data.items[i];
        if (current.line_price < 1) {

          const gift_current = all_free_gift_ids.flat().includes(current.variant_id);
          if (!gift_current) {

            const data_two = {
              updates: {
                [current.variant_id]: 0,
              }
            }
            fetch('/cart/update.js', {
              method: 'POST', // or 'PUT'
              headers: {
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
              },
              body: JSON.stringify(data_two),
            })
              .then(response => response.json())
              .then(response => {
                window.location.reload();
              });
          }
        }
      }
    });
  }

  //removeStaleGifts();

  var endlessScroll = new Ajaxinate();

  const intercept = (urlmatch, callback) => {
    let send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      this.addEventListener('readystatechange', function () {
        if (this.responseURL.includes(urlmatch) && this.readyState === 4) {
          callback(this);
        }
      }, false);
      send.apply(this, arguments);
    };
  };


  intercept('/cart', (data) => {
    const parsed = JSON.parse(data.response);

    const cart_data = parsed.items;


    for (let i = 0; i < window.freegifts.products.length; i++) {
      const currentTier = window.freegifts.products[i].tier;
      if (currentTier) {
        for (let z = 0; z < currentTier.length; z++) {
          const current_gift_in_tier = currentTier[z];
          const exists_in_cart = cart_data.find(x => x.product_id == current_gift_in_tier.id)
          const index_exists_in_cart = cart_data.findIndex(x => x.product_id == current_gift_in_tier.id)

          if (exists_in_cart) {
            const product_quantity = cart_data[index_exists_in_cart].quantity;

            if (product_quantity > 1) {
              const data = {
                'line': index_exists_in_cart + 1,
                'quantity': 1,
                sections: "cart-drawer,header"
              }

              fetch('/cart/change.js', {
                method: 'POST', // or 'PUT'
                headers: {
                  'Content-Type': 'application/json',
                  "Access-Control-Allow-Origin": "*"
                },
                body: JSON.stringify(data),
              })
                .then(response => response.json())
                .then(response => {
                  refreshCartItems(response);
                  // going to just reload until we can figure this piece out
                  //window.location.reload();
                });
            }
          }
        }
      }
    }
    //console.log(parsed);
  });

  const refreshCartItems = (response) => {
    return new Promise(async(resolve ,reject) => {
      const cartHTML = new DOMParser()
      .parseFromString(response.sections['cart-drawer'], 'text/html')
      .querySelector('cart-drawer-items');

      document.querySelector('cart-drawer-items').innerHTML = cartHTML.innerHTML

      //Delete Notification if present
      if(document.querySelector('.free-gifts-modal')){
        document.querySelector('.free-gifts-modal').remove();
      }
      resolve();
    });
    //disablecartlinks() ;

  }



  /* This is the Free Gifts Bubble */

  window.reRenderGifts = () => {
    return new Promise((resolve, reject) => {
      const freeGiftWraps = document.querySelectorAll('.evl-progress-bar__wrap');

      [...freeGiftWraps].forEach(wrap => {
        // Clear Existing
        wrap.innerHTML = "";

        for (let i = 0; i < window.freegifts.products.length; i++) {
          const currentGift = window.freegifts.products[i];

          const currentProduct = `
              <div data-free-gift data-free-gift-price="${currentGift.productPrice}">
                <div class="evl-progress-bar__item" style="--value:0">
                    <img src="${currentGift.product}"
                        class="evl-progress-bar__img" loading="lazy" />
                </div>
                <div class="evl-progress-bar__text-wrap">
                  <span class="evl-progress-bar__text">${currentGift.titleOverride}</span>
                  <span class="evl-progress-bar__price">$${currentGift.productPrice}</span>
                </div>
              </div>`;

          wrap.insertAdjacentHTML('beforeend', currentProduct);

        };

      });
      resolve();
    })
  }

  reRenderGifts();
  //disablecartlinks() ;
  const removeFreeGift = async (id) => {
    const data = {
      updates: {
        [id]: 0
      },
      sections: "cart-drawer,header"
    }

    await fetch('/cart/update.js', {
      method: 'POST', // or 'PUT'
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*"
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then( async(response) => {
        await refreshCartItems(response);
        window.renderCurrentState();
      });
  };

  let cartValue = 0;

  window.addEventListener("atc", async () => {
    await reRenderGifts();
    renderCurrentState();
  });


  window.fire_free_gifts_modal = (index) => {
    return new Promise(async(resolve, reject) => {

      // look at gifts and pop modal
      const productHolder = [];

      const current_free_gift = window.freegifts.products[index].tier;

      const returnLocalNumber = (number) => {
        return number.toLocaleString()
      }

      const createAddedString = (current_free_gift) => {
        return `
              <h5 class="free-gifts-modal-message">${current_free_gift.title} added to cart!</h5> 
          `
      };

      // If current gift has 1 variant and is solo
      if (current_free_gift && current_free_gift.length == 1 && current_free_gift[0].variants.length <= 1 && getCookie(current_free_gift[0].variants[0].id) != 1) {

        const data = {
          items: [
            {
              id: current_free_gift[0].variants[0].id,
              quantity: 1
            },
          ],
          sections: "cart-drawer,header"
        }

        // need a loader or sorts
        await fetch('/cart/add.js', {
          method: 'POST', // or 'PUT'
          headers: {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*"
          },
          body: JSON.stringify(data),
        })
          .then(response => response.json())
          .then( async(response) => {

            // going to just reload until we can figure this piece out

            /* Removing modal Clash 

            const createModal = () => {
              return `
                  <div class="free-gifts-modal">
                    <div class="free-gifts-modal-content">
                      <button class='modal-close' data-index='${index}'></button>
                    </div>
                  </div>
                `
            };
              document.body.insertAdjacentHTML('afterbegin', createModal(current_free_gift));
              document.querySelector('.free-gifts-modal-content').innerHTML = `Gift added to Cart!`;
            */

        
              await refreshCartItems(response);
              await new Promise(r => setTimeout(r, 500));
              window.renderCurrentState();
              resolve();
              //window.location.reload();
          });

        return;
      }


      // No Products Selected, this might be a placeholder gift like free-shipping
      if (current_free_gift.length == 0) {
        resolve();
        return;
      }

      for (let i = 0; i < current_free_gift.length; i++) {

        const currentTier = current_free_gift[i];

        const createOptions = currentTier.variants.map(variant => {
          if (variant.available) {
            return `
                <option value="${variant.id}">${variant.title}</option>
              `
          }
        });

        const createProductListing = (tier) => {
          return `
              <div class="free-gifts-modal-listing swiper-slide">
                  <img class="free-gifts-modal-img" src=${tier.featured_image} />
                    <div class="free-gifts-modal-select-wrap">
                      <select class="free-gifts-modal-select">
                            ${createOptions}
                      </select>
                      <button class="free-gifts-modal-add-to-cart">Add</button>
                    </div>
                  </div>
            `;
        };

        productHolder.push(createProductListing(currentTier));

      }

      const createModal = () => {
        return `
          <div class="free-gifts-modal" data-index='${index}'>
            <div class="free-gifts-modal-content modal-swiper">
              <button class='modal-close'></button>
              <span class="free-gifts-modal-title">Claim Your Free Gift!</span>
                          <div class="free-gifts-modal-content--wrap swiper-wrapper">
                            ${productHolder.toString().split(',').join('')}
                          </div>
                <div class="swiper-button-next">&nbsp;</div>
                <div class="swiper-button-prev">&nbsp;</div>
                <span class="free-gifts-modal-close"></span>
            </div>
          </div>
        `
      };

     document.body.insertAdjacentHTML('afterbegin', createModal(current_free_gift));

      const closeButton = document.querySelector('.free-gifts-modal-close');

      const addToCartButton = document.querySelectorAll('.free-gifts-modal-add-to-cart');

      // Close modal and store selection to cookie

      closeButton.addEventListener('click', () => {
        document.querySelector('.free-gifts-modal').remove();
      });


      [...addToCartButton].forEach(btn => {
        btn.addEventListener('click', async (event) => {

          currentElement = event.currentTarget;

          const free_gifts_select = currentElement.previousElementSibling;
          const selected_value = free_gifts_select.options[free_gifts_select.selectedIndex].value;

          //createAddedString(current_free_gift);
          document.querySelector('.free-gifts-modal-content').innerHTML = "Gift Added to Cart!";

          const data = {
            items: [
              {
                id: selected_value,
                quantity: 1
              }
            ],
            sections: "cart-drawer,header"
          }

          await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*"
            },
            body: JSON.stringify(data),
          })
            .then(response => response.json())
            .then( async(response) => {
              await refreshCartItems(response);
              await new Promise(r => setTimeout(r, 500));
              window.renderCurrentState();
              resolve();
            });
        })

        var swiper = new Swiper(".modal-swiper", {
          slidesPerView: "auto",
          centeredSlides: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }
        });
      });
    })  
  }

  // fire this on load
  window.renderCurrentState = async () => {
    const free_gifts = document.querySelectorAll("#free-gift-bubbles");
    await fetch('/cart.js')
      .then((response) => response.json())
      .then(data => {
        [...free_gifts].forEach(async (parent_gift, index) => {
          let active = true;
          let moreFreeGifts = parent_gift.querySelectorAll("[data-free-gift]");
          [...moreFreeGifts].forEach(async (gift, index) => {

            const currentGiftPrice = parseInt(gift.dataset.freeGiftPrice);
            cartValue = data.items_subtotal_price / 100;

            gift.querySelector(".evl-progress-bar__item").classList.remove("finished");

            const compareGiftsToCart = (index) => {

              const cart_data = data.items;

              for (let i = index; i < window.freegifts.products.length; i++) {
                const currentTier = window.freegifts.products[i].tier;
                if (currentTier) {
                  for (let z = 0; z < currentTier.length; z++) {
                    const current_gift_in_tier = currentTier[z];
                    const exists_in_cart = cart_data.find(x => x.product_id == current_gift_in_tier.id)

                    if (exists_in_cart) {
                      removeFreeGift(exists_in_cart.id)
                    }
                  }
                }
              }
            }

            if (active) {
              switch (cartValue >= currentGiftPrice) {
                case true:
                  gift.querySelector(".evl-progress-bar__item").style.animation = 'none';
                  gift.querySelector(".evl-progress-bar__item").offsetHeight;
                  gift.querySelector(".evl-progress-bar__item").style.animation = null;
                  gift.querySelector(".evl-progress-bar__item").style.setProperty("--value", 100);
                  gift.querySelector(".evl-progress-bar__item").classList.add("finished");
                  // fire free gift modal
                  // only fire once
                  if (!document.querySelector('.free-gifts-modal')) {

                    // double check item is not in cart already
                    window.freegifts.products[index].tier;

                    let found = false;

                    const cart_data = data.items.map(product => product.product_id);

                    for (let i = index; i < window.freegifts.products.length; i++) {

                      const currentTier = window.freegifts.products[i].tier;

                      if (currentTier) {
                        for (let z = 0; z < currentTier.length; z++) {

                          const current_gift_in_tier = currentTier[z];

                          const exists_in_cart = cart_data.find(x => x == current_gift_in_tier.id)

                          if (exists_in_cart) {
                            found = true;
                          }
                        }
                      }
                    }

                    if (!found) {
                      if(getCookie(window.freegifts.products[index].tier[0].variants[0].id) != 1) {
                        var hdl = "no_gift_alert_" + index;
                        if(getCookie(hdl) != 1) {
                          await window.fire_free_gifts_modal(index);
                        }
                      }
                    }

                  }
                  break;
                case false:
                  const percentageValue = parseFloat((
                    (cartValue / currentGiftPrice) *
                    100
                  ).toFixed(2));
                  gift.querySelector(".evl-progress-bar__item").style.animation = 'none';
                  gift.querySelector(".evl-progress-bar__item").offsetHeight;
                  gift.querySelector(".evl-progress-bar__item").style.animation = null;
                  gift.querySelector(".evl-progress-bar__item").style.setProperty("--value", percentageValue);
                  parent_gift.querySelector('[data-away-from]').innerHTML = `$${Math.abs(cartValue - currentGiftPrice).toFixed(2)}`;
                  active = false;
                  compareGiftsToCart(index);

                default:
                  break;
              }
            }
          })
        });
      });
  }

  renderCurrentState();

  // Custom supplement facts
  // Order of supplement facts needs to follow order of variants

  const flavorDropdown = document.querySelector('select[name*="options"');

  if (flavorDropdown) {
    const supFactsOriginalOrder = document.querySelector('#sup-facts').innerHTML;

    const thumbnailsOriginal = document.querySelectorAll('.thumbnail-list li');
    const og_order = [];
    thumbnailsOriginal.forEach(thumb => {
      og_order.push(thumb);
    });

    const createSlides = (index) => {
      const start_here = (index > 0) ? index * 4 : index;
      // times minimum

      const injected_slides = [];

      for (let i = start_here; i < start_here + 4; i++) {
        injected_slides.push(og_order[i]);
      }

      const thumbnailsOriginalList = document.querySelector('.thumbnail-list');
      thumbnailsOriginalList.innerHTML = "";
      for (let x = 0; x < injected_slides.length; x++) {
        thumbnailsOriginalList.appendChild(injected_slides[x]);
      }

    }

    flavorDropdown.addEventListener('change', (event) => {
      const currentIndex = event.target.selectedIndex;

      createSlides(currentIndex)

      const supplement_facts_panel = document.querySelector('#sup-facts');

      supplement_facts_panel.innerHTML = supFactsOriginalOrder;

      const dropdownPanel = document.querySelector('.supplement-facts-dropdown summary');

      if (dropdownPanel.ariaExpanded === "true") {

      } else {
        // dropdownPanel.click();
      }

      const dropDownImage = document.querySelectorAll('#sup-facts img')[currentIndex];

      supplement_facts_panel.prepend(dropDownImage);

    });
  }

   
  
});


function changeAnnouncement() {
  var announcements = document.querySelectorAll("#shopify-section-announcement-bar .announcement-bar");
  if (announcements.length > 0) {
    for (var i = 0; i < announcements.length; i++) {
      var ann = announcements[i];

      if (ann.classList.contains("active")) {
        var j = (i + 1) % announcements.length;
        announcements[j].classList.add("active");
        ann.classList.remove("active");
        break;
      }
    }
  }
}

setInterval(changeAnnouncement, 6000);

document.querySelectorAll(".card select[name=id]").forEach(function(obj) {
  obj.addEventListener("change", function(e) {
    var card = obj.closest(".card");
    var p = obj.options[obj.selectedIndex].getAttribute("data-price");
    card.querySelector("span.price-item").textContent = p;
  });
});

// Cookie JS
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

document.addEventListener("click", function(e) {
  if(e.target.tagName == 'cart-remove-button') {
    console.log("gift", e.target.getAttribute("data-id"));
    if(e.target.closest(".cart-item__quantity").classList.contains("for_promo")) {
      setCookie(e.target.getAttribute("data-id"), 1, 365);
    }
  }
  if(e.target.closest("cart-remove-button")) {
    console.log("gift", e.target.closest("cart-remove-button").getAttribute("data-id"));
    if(e.target.closest(".cart-item__quantity").classList.contains("for_promo")) {
      setCookie(e.target.closest("cart-remove-button").getAttribute("data-id"), 1, 365);
    }
  }

  if(e.target.classList.contains("free-gifts-modal")) {
    e.target.remove();
    var hdl = "no_gift_alert_" + e.target.getAttribute("data-index");
    // setCookie(hdl, 1, 365);
  }

  if(e.target.classList.contains("modal-close")) {
    if(e.target.closest(".free-gifts-modal")) {
      e.target.closest(".free-gifts-modal").remove();
      var hdl = "no_gift_alert_" + e.target.closest(".free-gifts-modal").getAttribute("data-index");
      // setCookie(hdl, 1, 365);
    }
  }
  //disablecartlinks() ;
});



function disablecartlinks() {
   const cartdrawer = document.getElementsByClassName("cart-item__name h4 break");
    for(var i = 0; i < cartdrawer.length; i++) {
     cartdrawer[i].removeAttribute('href');
    }
    const cartdrawerimage = document.getElementsByClassName("cart-item__link");
    for(var i = 0; i < cartdrawerimage.length; i++) {
     cartdrawerimage[i].removeAttribute('href');
  }
}
   
